import Navbar from '../Navbar';
// import ApiPage from '../ApiPage';
// const options = [
// 	{
// 		label: 'Deltas',
// 		value: 'delta/latest_cursor',
// 	},
// ];

export default function View(props) {
	return (
		<>
			<Navbar />
			<div align="center">WORK IN PROGRESS</div>
		</>
	);
}
